import React from 'react'
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'antd';

const CustomBreadcrumb = ({ breadcrumbList }) => {
    return (
        <div className='mb-3'>
            <Breadcrumb separator=">">
                {breadcrumbList.map((item, index) => (
                    <Breadcrumb.Item key={index}>
                        {item.href ? (
                            <Link to={item.href} className='text-decoration-none'>{item.title}</Link>
                        ) : (
                            item.title
                        )}
                    </Breadcrumb.Item>
                ))}
            </Breadcrumb>
        </div>
    )
}

export default CustomBreadcrumb;